import { render, staticRenderFns } from "./OrderAccordionItem.vue?vue&type=template&id=6c5bf761&scoped=true&"
import script from "./OrderAccordionItem.vue?vue&type=script&lang=js&"
export * from "./OrderAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5bf761",
  null
  
)

export default component.exports